module.exports = __webpack_public_path__ + "img/MR.4ae40103.svg";